import { z } from 'zod';
import { sectionHasValue } from '../util';
export const baseOstomySchema = z.object({
    wnl: z.boolean().optional(),
    present: z.string().optional(),
    location: z.string().optional(),
    status: z.string().optional(),
    amtDrainage: z.string().optional(),
    ostomyType: z.string().optional(),
    ostomyAge: z.string().optional(),
    ostomySurgeryDate: z.string().optional(),
    recentComplication: z.array(z.string()).optional(),
    hospitalizationDetail: z.string().optional(),
    stomaColor: z.string().optional(),
    stomaShape: z.string().optional(),
    stomaHeight: z.string().optional(),
    stomaWidthMm: z.string().optional(),
    stomaHeightMm: z.string().optional(),
    stomaSizeChange: z.string().optional(),
    stomaMucosa: z.array(z.string()).optional(),
    stomaFunction: z.string().optional(),
    skinZone1: z.string().optional(),
    skinZone2: z.string().optional(),
    skinZone3: z.string().optional(),
    leakageHistory: z.string().optional(),
    leakageCause: z.array(z.string()).optional(),
    applianceSystem: z.string().optional(),
    waferType: z.string().optional(),
    applianceBrand: z.string().optional(),
    accessories: z.array(z.string()).optional(),
    pouchChangeThisVisit: z.string().optional(),
    daysSinceWaferChange: z.string().optional(),
    waferOpeningMm: z.string().optional(),
    outputConsistency: z.string().optional(),
    outputColor: z.string().optional(),
    outputVolume: z.string().optional(),
    outputOdor: z.string().optional(),
    whoManages: z.array(z.string()).optional(),
    skillLevel: z.string().optional(),
    techniqueObserved: z.array(z.string()).optional(),
    educationTopics: z.array(z.string()).optional(),
    educationLearner: z.array(z.string()).optional(),
    educationComprehension: z.string().optional(),
    supplyAdequacy: z.string().optional(),
    abnormalStomaAppearance: z.boolean().optional(),
    abnormalSurroundingSkin: z.boolean().optional(),
    requiresTraining: z.boolean().optional(),
    dialysis: z.array(z.string()).optional(),
    mdNotifTime: z.string().optional(),
    mdOrders: z.string().optional(),
    ostomyNarrative: z.string().optional(),
    ostomyChange: z.string().optional(),
});
export const baseOstomySchemaRefined = baseOstomySchema.refine((data) => sectionHasValue(data), {
    message: 'Mark as within normal limits if none applies',
    path: [],
});
